<template>
  <div class="mt-4">
    <div class="mb-2" v-show="loginErrorMsgVisible">
      <error>
        {{ lang.auth.failed }}
      </error>
    </div>

    <div class="grid grid-cols-1 sm:grid-cols-2 gap-4">
      <!-- Email -->
      <input-text
        type="email"
        name="login_email"
        id="login_email"
        :required="true"
        autocomplete="email"
        :label="lang.labels.email"
        v-model="login_email"
      ></input-text>

      <!-- Password -->
      <input-text
        type="password"
        name="login_password"
        id="login_password"
        autocomplete="password"
        :required="true"
        :label="lang.labels.password"
        v-model="login_password"
      ></input-text>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue';
import axios from 'axios';
import InputText from "../inputs/InputText.vue";
import Error from "../alerts/Error.vue";

const props = defineProps({
  lang: Object,
});

const emit = defineEmits(['success']);

const login_email = ref("");
const login_password = ref("");
const loginErrorMsgVisible = ref(false);

const isValid = computed(() => {
  return login_email.value.trim() !== "" && login_password.value.trim() !== "";
});

const authenticate = () => {
  loginErrorMsgVisible.value = false;

  if (login_email.value === "" || login_password.value === "") {
    return Promise.reject(new Error("Email and password are required"));
  }

  return axios
    .post(`/web-api/login`, {
      email: login_email.value,
      password: login_password.value,
    })
    .then((response) => {
      if (response.data.csrf_token) {
        window.axios.defaults.headers.common['X-CSRF-TOKEN'] = response.data.csrf_token;
        document.querySelector('meta[name="csrf-token"]').setAttribute('content', response.data.csrf_token);
      }
      emit('success', 'login');
      return response;
    })
    .catch((error) => {
      loginErrorMsgVisible.value = true;
      throw error;
    });
};

defineExpose({
  authenticate,
  isValid,
});
</script>
